import { useCallback } from "react";

import { ConfigFileStatusType } from "../../../entities/ConfigFileStatus";
import { useTerminalContext } from "../contexts/TerminalContext";

/**
 * Hook for managing config state in the TerminalContext
 */
export const useConfigState = () => {
  const {
    setConfigState: setConfigStateBatch,
    clearConfigState: clearConfigStateBatch,
  } = useTerminalContext();

  const clearConfigState = useCallback(() => {
    clearConfigStateBatch();
  }, [clearConfigStateBatch]);

  const setConfigState = useCallback(
    (config: any, status: ConfigFileStatusType | null, src?: string | null) => {
      // Use batch action to update all config state in one render
      setConfigStateBatch(config, status, src);
    },
    [setConfigStateBatch]
  );

  const throwNoConfigFound = useCallback(() => {
    clearConfigState();
    throw new Error("NO_CONFIG_FOUND");
  }, [clearConfigState]);

  return {
    clearConfigState,
    setConfigState,
    throwNoConfigFound,
  };
};
